/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCheckRegular: {
  name: 'check-regular';
  data: string;
} = {
  name: 'check-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M20.293 5.204a1.18 1.18 0 0 0-.28.091c-.062.033-2.525 2.473-5.473 5.422L9.18 16.08l-2.54-2.538c-1.947-1.945-2.582-2.557-2.72-2.619-.514-.232-1.135.034-1.341.573-.083.219-.065.576.041.788.089.179 5.919 6.007 6.098 6.097.076.038.248.078.382.089.485.039.043.448 6.447-5.961 6.409-6.415 5.967-5.936 5.923-6.423-.024-.268-.096-.426-.273-.603a.99.99 0 0 0-.904-.279"/></svg>`
};
